import { action } from 'satcheljs';

/**
 * This action is to be dispatched after search is exited and we need
 * to re-select the previous node the user was on before entering into
 * their search session.
 */
const selectPreviousNode = action('SELECT_PREVIOUS_NODE_NEXT', (actionSource: string) => ({
    actionSource: actionSource,
}));

export default selectPreviousNode;
